import { Component, Input } from '@angular/core';

/**
 * Toolbar item inside the toolbar
 */
@Component({
    selector: 'ngx-remote-desktop-toolbar-item',
    template: `
        <ng-content></ng-content>
    `
})
export class ToolbarItemComponent {
    @Input() align: string;
}
